import { createStore } from 'vuex'

export default createStore({
  state: {
    pass: '',
    token: '',
  },
  getters: {},
  mutations: {
    setPass(state, pass) {
      state.pass = pass
      localStorage.pass = pass
    },
    setToken(state, token) {
      state.token = token
      localStorage.token = token
    },
  },
  actions: {},
  modules: {},
})
